export default __webpack_public_path__ + "static/media/vip.a1b19ea4.svg";